(function () {
  var geoCache = {};
  var geoapifyAbortController = null;

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/\bmt\b\.?/g, " mount ")
      .replace(/\bst\b\.?/g, " saint ")
      .replace(/\bft\b\.?/g, " fort ")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function readJsonScript(root, selector) {
    var node = root.querySelector(selector);

    if (!node) return [];

    try {
      return JSON.parse(node.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function getGeoapifyUrl(query, apiKey) {
    return (
      "https://api.geoapify.com/v1/geocode/search?text=" +
      encodeURIComponent(query || "") +
      "&limit=5&format=geojson&apiKey=" +
      encodeURIComponent(apiKey || "")
    );
  }

  function extractGeoapifyCandidates(data, toNumber) {
    return ((data && data.features) || [])
      .map(function (feature) {
        var properties = feature && feature.properties ? feature.properties : {};
        var coordinates =
          feature &&
          feature.geometry &&
          Array.isArray(feature.geometry.coordinates)
            ? feature.geometry.coordinates
            : [];
        var lat = toNumber(coordinates[1]);
        var lng = toNumber(coordinates[0]);

        if (!feature || lat === null || lng === null) return null;

        return {
          name:
            properties.city ||
            properties.town ||
            properties.village ||
            properties.county ||
            properties.name ||
            properties.formatted ||
            "",
          country: properties.country || properties.country_code || "",
          state: properties.state || "",
          stateCode: properties.state_code || "",
          lat: lat,
          lng: lng,
        };
      })
      .filter(Boolean);
  }

  function resolveGeoLocation(query, apiKey, toNumber) {
    var cacheKey = "home_events_search_geoapify_v1_" + compact(query);
    var stored;

    if (!apiKey || !String(query || "").trim()) return Promise.resolve(null);

    if (Object.prototype.hasOwnProperty.call(geoCache, cacheKey)) {
      return Promise.resolve(geoCache[cacheKey]);
    }

    try {
      stored = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
      if (stored && Date.now() - stored.timestamp < 1000 * 60 * 60) {
        geoCache[cacheKey] = stored.value;
        return Promise.resolve(stored.value);
      }
    } catch (error) {
      // Ignore storage failures.
    }

    if (geoapifyAbortController) geoapifyAbortController.abort();
    geoapifyAbortController =
      "AbortController" in window ? new AbortController() : null;

    return fetch(getGeoapifyUrl(query, apiKey), {
      signal: geoapifyAbortController
        ? geoapifyAbortController.signal
        : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Geoapify request failed");
        return response.json();
      })
      .then(function (data) {
        var value = extractGeoapifyCandidates(data, toNumber)[0] || null;

        geoCache[cacheKey] = value;

        try {
          sessionStorage.setItem(
            cacheKey,
            JSON.stringify({
              timestamp: Date.now(),
              value: value,
            })
          );
        } catch (error) {
          // Ignore storage failures.
        }

        return value;
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return null;
        return null;
      });
  }


  function dedupeByUrl(items) {
    var seen = {};

    return items.filter(function (item) {
      var key = normalize(
        item.url || item.cityUrl || item.title || item.cityName,
      );

      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function splitCategoryList(value) {
    if (Array.isArray(value)) return value.map(String).filter(Boolean);

    return String(value || "")
      .split(/[,;\n|]+/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function splitMappingList(value) {
    if (Array.isArray(value)) {
      return value
        .reduce(function (items, item) {
          return items.concat(splitMappingList(item));
        }, [])
        .filter(Boolean);
    }

    return String(value || "")
      .split(/[,;\n|•·]+/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function compact(value) {
    return normalize(value).replace(/\s+/g, "");
  }

  function handleize(value) {
    return normalize(value).replace(/\s+/g, "-").replace(/^-|-$/g, "");
  }

  function uniqueDisplayParts(parts) {
    var accepted = [];

    function getDisplayKey(part) {
      return normalize(part)
        .replace(/\b(city|town|village|borough)\b/g, "")
        .trim();
    }

    parts.forEach(function (part) {
      var key = normalize(part);
      var displayKey = getDisplayKey(part);
      var isContained;

      if (!key) return;

      isContained = accepted.some(function (acceptedPart) {
        var acceptedKey = normalize(acceptedPart);
        var acceptedDisplayKey = getDisplayKey(acceptedPart);

        return (
          acceptedKey.indexOf(key) !== -1 ||
          key.indexOf(acceptedKey) !== -1 ||
          (displayKey.length > 3 && acceptedKey.indexOf(displayKey) !== -1) ||
          (acceptedDisplayKey.length > 3 &&
            key.indexOf(acceptedDisplayKey) !== -1)
        );
      });

      if (!isContained) accepted.push(part);
    });

    return accepted;
  }

  function initHomeEventsHeroSearch(root) {
    var nearbyEventRadiusMiles = 150;
    var nearbyLocationRadiusMiles = 250;
    var panel = root.querySelector("[data-home-events-hero-search-panel]");
    var form = root.querySelector("[data-home-events-hero-search-form]");
    var input = root.querySelector("[data-home-events-hero-search-input]");
    var predictive = root.querySelector("[data-home-events-predictive-search]");
    var overlay = root.querySelector("[data-home-events-search-overlay]");
    var tabs = Array.prototype.slice.call(
      root.querySelectorAll("[data-home-events-hero-search-tab]"),
    );
    var tabInput = root.querySelector(
      "[data-home-events-hero-search-tab-input]",
    );
    var select = root.querySelector("[data-home-events-hero-search-select]");
    var selectButton = root.querySelector(
      "[data-home-events-hero-search-select-button]",
    );
    var selectLabel = root.querySelector(
      "[data-home-events-hero-search-select-label]",
    );
    var selectList = root.querySelector(
      "[data-home-events-hero-search-select-list]",
    );
    var selectOptions = Array.prototype.slice.call(
      root.querySelectorAll("[data-home-events-hero-search-select-option]"),
    );
    var allResultsLink = root.querySelector(
      "[data-home-events-predictive-search-all-results]",
    );
    var allResultsTerm = root.querySelector(
      "[data-home-events-predictive-search-term]",
    );
    var locationList = root.querySelector(
      "[data-home-events-location-results]",
    );
    var eventList = root.querySelector("[data-home-events-event-results]");
    var eventTypeList = root.querySelector(
      "[data-home-events-event-type-results]",
    );
    var eventTypeEmpty = root.querySelector(
      "[data-home-events-event-type-empty]",
    );
    var nearbyWrap = root.querySelector(
      ".home-events-predictive-search__nearby-wrap",
    );
    var nearbyButtons = Array.prototype.slice.call(
      root.querySelectorAll("[data-home-events-nearby-trigger]"),
    );
    var nearbyStatus = root.querySelector("[data-home-events-nearby-status]");
    var searchUtils = window.CityGuideSearchUtils || {};
    var normalizeUrl =
      searchUtils.normalizeUrl ||
      function (url) {
        return String(url || "");
      };
    var toNumber =
      searchUtils.toNumber ||
      function (value) {
        var number = parseFloat(value);
        return Number.isFinite(number) ? number : null;
      };
    var calculateDistanceMiles =
      searchUtils.calculateDistanceMiles ||
      function () {
        return Number.POSITIVE_INFINITY;
      };
    var getStateQuery =
      searchUtils.getStateQuery ||
      function () {
        return "";
      };
    var cityHubs = searchUtils.parseCityHubs
      ? searchUtils.parseCityHubs(
          readJsonScript(root, "[data-home-events-city-hubs]"),
        )
      : [];
    var locationIndex = readJsonScript(root, "[data-home-events-location-index]")
      .map(function (location) {
        return {
          title: location.title || "",
          url: normalizeUrl(location.url || ""),
          keywords: splitMappingList(location.keywords),
          isLocation: location.isLocation === true || String(location.isLocation) === "true",
        };
      })
      .filter(function (location) {
        return !!(location.title && location.url);
      });
    var rawLocationMappings = readJsonScript(
      root,
      "[data-home-events-location-mapping-index]",
    );
    var locationMappings = searchUtils.parseLocationMappings
      ? searchUtils.parseLocationMappings(rawLocationMappings, cityHubs)
      : rawLocationMappings
          .map(function (mapping) {
            var parentUrl = normalizeUrl(mapping.parentCityPageUrl || "");
            var parentTitle =
              mapping.parentCityPageTitle ||
              mapping.searchCity ||
              mapping.displayName ||
              "";
            var hub =
              cityHubs.find(function (cityHub) {
                return (
                  parentUrl &&
                  normalizeUrl(cityHub.url || cityHub.cityUrl) === parentUrl
                );
              }) ||
              cityHubs.find(function (cityHub) {
                return (
                  parentTitle &&
                  normalize(cityHub.title || cityHub.cityName) ===
                    normalize(parentTitle)
                );
              }) ||
              null;

            if (!parentUrl && parentTitle) {
              parentUrl =
                "/pages/" +
                parentTitle
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/^-|-$/g, "");
            }

            return {
              searchCity:
                mapping.searchCity || mapping.displayName || parentTitle,
              displayName:
                mapping.displayName || mapping.searchCity || parentTitle,
              state: mapping.state || "",
              stateCode: mapping.stateCode || "",
              zipCodes: splitMappingList(mapping.zipCodes),
              searchAliases: splitMappingList(mapping.searchAliases),
              neighborhoods: splitMappingList(mapping.neighborhoods),
              parentCityPageTitle: parentTitle,
              parentCityPageUrl:
                parentUrl ||
                (hub && normalizeUrl(hub.url || hub.cityUrl)) ||
                "",
              isHubCity:
                mapping.isHubCity === true ||
                String(mapping.isHubCity) === "true",
              lat: toNumber(mapping.lat || mapping.latitude),
              lng: toNumber(mapping.lng || mapping.longitude),
              hub: hub || null,
            };
          })
          .filter(function (mapping) {
            return !!(mapping.searchCity && mapping.parentCityPageUrl);
          });
    var eventIndex = readJsonScript(root, "[data-home-events-event-index]")
      .map(function (event) {
        var locationParts = uniqueDisplayParts([
          event.location,
          event.city,
          event.stateCode || event.state,
        ]).join(", ");

        return {
          title: event.title || "",
          url: normalizeUrl(event.url || ""),
          location: locationParts || "",
          categories: splitCategoryList(event.category),
          image: event.image || "",
          city: event.city || "",
          state: event.state || "",
          stateCode: event.stateCode || "",
          zip: event.zip || "",
          lat: toNumber(event.lat),
          lng: toNumber(event.lng),
        };
      })
      .filter(function (event) {
        return !!(event.title && event.url);
      });
    var defaultLocationListHtml = locationList ? locationList.innerHTML : "";
    var defaultEventListHtml = eventList ? eventList.innerHTML : "";
    var defaultEventTypeListHtml = eventTypeList ? eventTypeList.innerHTML : "";
    var currentMode = "all";
    var isOpen = false;
    var nearbyResultsActive = false;
    var autocompleteRequestId = 0;
    var geoapifyApiKey = predictive ? predictive.dataset.geoapifyApiKey || "" : "";

    if (!panel || !form || !input || !predictive) return;

    function scrollSearchIntoView() {
      var rect = panel.getBoundingClientRect();
      var targetTop;

      if (rect.top >= 24 && rect.top <= window.innerHeight * 0.28) return;

      targetTop = window.pageYOffset + rect.top - 24;
      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: "smooth",
      });
    }

    function openSearch(shouldScroll) {
      isOpen = true;
      root.classList.add("is-search-open");
      panel.classList.add("is-open");
      predictive.classList.add("is-visible");
      if (overlay) overlay.classList.add("is-visible");
      if (shouldScroll !== false) scrollSearchIntoView();
      updateVisibleSuggestions();
    }

    function closeSearch() {
      isOpen = false;
      root.classList.remove("is-search-open");
      panel.classList.remove("is-open");
      predictive.classList.remove("is-visible");
      if (overlay) overlay.classList.remove("is-visible");
      closeMobileSelect();
    }

    function closeMobileSelect() {
      root.classList.remove("is-mobile-select-open");
      if (selectList) selectList.hidden = true;
      if (selectButton) selectButton.setAttribute("aria-expanded", "false");
    }

    function setMode(mode, placeholder, label) {
      currentMode = mode || "all";
      if (!nearbyResultsActive) restoreDefaultResults();
      predictive.dataset.mode = currentMode;
      if (tabInput) tabInput.value = currentMode;
      if (placeholder) input.setAttribute("placeholder", placeholder);
      if (select && select.value !== currentMode) select.value = currentMode;
      if (selectLabel && label) selectLabel.textContent = label;

      tabs.forEach(function (tab) {
        tab.classList.toggle("is-active", tab.dataset.tab === currentMode);
      });

      selectOptions.forEach(function (option) {
        var active = option.dataset.value === currentMode;
        option.classList.toggle("is-active", active);
        option.setAttribute("aria-selected", active ? "true" : "false");
      });

      updateVisibleSuggestions();
      closeMobileSelect();
    }

    function filterList(list, query) {
      var visibleCount = 0;
      var currentEventTypeEmpty = eventTypeList
        ? eventTypeList.querySelector("[data-home-events-event-type-empty]")
        : null;

      if (!list) return 0;

      Array.prototype.slice
        .call(list.querySelectorAll("li"))
        .forEach(function (item) {
          if (item === currentEventTypeEmpty) return;

          var text = normalize(
            item.dataset.eventTypeTitle || item.textContent || "",
          );
          var visible = !query || text.indexOf(query) !== -1;

          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

      return visibleCount;
    }

    function updateAllResults(query) {
      var url;

      if (allResultsTerm)
        allResultsTerm.textContent = input.value.trim() || "New";
      if (!allResultsLink) return;

      url = new URL(
        allResultsLink.getAttribute("href"),
        window.location.origin,
      );
      url.searchParams.set("q", input.value.trim() || "New");
      url.searchParams.set("type", "page,article");
      url.searchParams.set("options[prefix]", "last");
      allResultsLink.setAttribute("href", url.pathname + url.search + url.hash);
    }

    function getLocationMappingTerms(mapping) {
      return [
        mapping.searchCity,
        mapping.displayName,
        mapping.state,
        mapping.stateCode,
        mapping.parentCityPageTitle,
      ]
        .concat(mapping.zipCodes || [])
        .concat(mapping.searchAliases || [])
        .concat(mapping.neighborhoods || [])
        .filter(Boolean);
    }

    function normalizedListContains(items, normalizedValue) {
      return (items || []).some(function (item) {
        return normalize(item) === normalizedValue;
      });
    }

    function normalizedListStartsWith(items, normalizedValue) {
      return (items || []).some(function (item) {
        return normalize(item).indexOf(normalizedValue) === 0;
      });
    }

    function normalizedListIncludes(items, normalizedValue) {
      return (items || []).some(function (item) {
        return normalize(item).indexOf(normalizedValue) !== -1;
      });
    }

    function scoreLocationMapping(query, mapping) {
      var normalizedQuery = normalize(query);
      var compactQuery = compact(query);
      var queryWords = normalizedQuery.split(" ").filter(Boolean);
      var stateQuery = getStateQuery(query);
      var terms = getLocationMappingTerms(mapping);
      var normalizedTerms = terms.map(normalize).filter(Boolean);
      var combinedTerms = normalizedTerms.join(" ");
      var normalizedZipCodes = (mapping.zipCodes || []).map(normalize);
      var normalizedAliases = (mapping.searchAliases || []).map(normalize);
      var normalizedNeighborhoods = (mapping.neighborhoods || []).map(
        normalize
      );
      var normalizedSearchCity = normalize(mapping.searchCity);
      var normalizedDisplayName = normalize(mapping.displayName);
      var normalizedParentTitle = normalize(mapping.parentCityPageTitle);
      var score = 0;

      if (!normalizedQuery) return 0;

      if (normalizedListContains(mapping.searchAliases, normalizedQuery)) {
        score = Math.max(score, 500);
      }

      if (normalizedListContains(mapping.zipCodes, normalizedQuery)) {
        score = Math.max(score, 480);
      }

      if (
        normalizedSearchCity === normalizedQuery ||
        normalizedDisplayName === normalizedQuery
      ) {
        score = Math.max(score, 460);
      }

      if (normalizedListContains(mapping.neighborhoods, normalizedQuery)) {
        score = Math.max(score, 420);
      }

      if (normalizedParentTitle === normalizedQuery) {
        score = Math.max(score, 380);
      }

      if (normalizedQuery.length >= 3) {
        if (normalizedListStartsWith(mapping.searchAliases, normalizedQuery)) {
          score = Math.max(score, 340);
        } else if (
          normalizedSearchCity.indexOf(normalizedQuery) === 0 ||
          normalizedDisplayName.indexOf(normalizedQuery) === 0
        ) {
          score = Math.max(score, 330);
        } else if (
          normalizedListStartsWith(mapping.neighborhoods, normalizedQuery)
        ) {
          score = Math.max(score, 280);
        } else if (
          normalizedListIncludes(mapping.searchAliases, normalizedQuery)
        ) {
          score = Math.max(score, 260);
        } else if (
          normalizedSearchCity.indexOf(normalizedQuery) !== -1 ||
          normalizedDisplayName.indexOf(normalizedQuery) !== -1
        ) {
          score = Math.max(score, 250);
        } else if (
          normalizedListIncludes(mapping.neighborhoods, normalizedQuery)
        ) {
          score = Math.max(score, 190);
        }
      }

      terms.forEach(function (term) {
        var normalizedTerm = normalize(term);
        var compactTerm = compact(term);

        if (!normalizedTerm) return;

        if (compactQuery === compactTerm) {
          if (normalizedZipCodes.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 480);
          } else if (normalizedAliases.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 500);
          } else if (
            normalizedSearchCity === normalizedTerm ||
            normalizedDisplayName === normalizedTerm
          ) {
            score = Math.max(score, 460);
          } else if (normalizedParentTitle === normalizedTerm) {
            score = Math.max(score, 380);
          } else if (normalizedNeighborhoods.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 420);
          } else {
            score = Math.max(score, 300);
          }
          return;
        }

        if (
          normalizedQuery.length >= 3 &&
          normalizedTerm.indexOf(normalizedQuery) === 0
        ) {
          if (normalizedAliases.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 340);
          } else if (
            normalizedSearchCity === normalizedTerm ||
            normalizedDisplayName === normalizedTerm
          ) {
            score = Math.max(score, 330);
          } else if (normalizedNeighborhoods.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 280);
          } else {
            score = Math.max(score, 240);
          }
        } else if (
          normalizedQuery.length >= 3 &&
          normalizedTerm.indexOf(normalizedQuery) !== -1
        ) {
          if (normalizedAliases.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 260);
          } else if (
            normalizedSearchCity === normalizedTerm ||
            normalizedDisplayName === normalizedTerm
          ) {
            score = Math.max(score, 250);
          } else if (normalizedNeighborhoods.indexOf(normalizedTerm) !== -1) {
            score = Math.max(score, 190);
          } else {
            score = Math.max(score, 120);
          }
        }
      });

      if (
        queryWords.length > 1 &&
        queryWords.every(function (word) {
          return combinedTerms.indexOf(word) !== -1;
        })
      ) {
        score = Math.max(score, 220 + queryWords.length);
      }

      if (
        stateQuery &&
        (normalize(mapping.state) === stateQuery ||
          normalize(mapping.stateCode) === normalize(query) ||
          normalize(mapping.stateCode) === normalize(stateQuery))
      ) {
        score = Math.max(score, 160);
      }

      if (mapping.isHubCity && score > 0) score += 5;

      return score;
    }

    function mappingToLocationResult(mapping, score) {
      var hub = mapping.hub || {};
      var parentTitle =
        hub.title ||
        hub.cityName ||
        mapping.parentCityPageTitle;
      var title =
        mapping.displayName ||
        mapping.searchCity ||
        parentTitle;
      var url = normalizeUrl(
        hub.url || hub.cityUrl || mapping.parentCityPageUrl,
      );
      var labelParts = [];

      if (parentTitle && normalize(parentTitle) !== normalize(title)) {
        labelParts.push(parentTitle);
      }

      labelParts = labelParts.concat([mapping.state, mapping.stateCode]);

      return {
        title: title,
        url: url,
        label: uniqueDisplayParts(labelParts).join(", "),
        score: score || 0,
      };
    }

    function hubToLocationResult(hub, score) {
      return {
        title: hub.title || hub.cityName,
        url: normalizeUrl(hub.url || hub.cityUrl),
        label: uniqueDisplayParts([hub.state, hub.stateCode]).join(", "),
        score: score || 0,
      };
    }

    function locationPageToResult(location, query) {
      var normalizedQuery = normalize(query);
      var title = normalize(location.title);
      var keywords = (location.keywords || []).map(normalize).filter(Boolean);
      var combined = [title].concat(keywords).join(" ");
      var score = 0;

      if (!normalizedQuery) return Object.assign({}, location, { score: 0 });

      if (title === normalizedQuery) {
        score = 360;
      } else if (
        keywords.some(function (keyword) {
          return keyword === normalizedQuery;
        })
      ) {
        score = 340;
      } else if (title.indexOf(normalizedQuery) === 0) {
        score = 300;
      } else if (
        keywords.some(function (keyword) {
          return keyword.indexOf(normalizedQuery) === 0;
        })
      ) {
        score = 280;
      } else if (combined.indexOf(normalizedQuery) !== -1) {
        score = 220;
      }

      return {
        title: location.title,
        url: location.url,
        label: location.isLocation ? "Location" : "Page",
        score: score,
      };
    }

    function getLocationSearchMatches(query, limit) {
      var normalizedQuery = normalize(query);
      var compactQuery = compact(query);
      var stateQuery = getStateQuery(query);
      var locationPageResults = locationIndex
        .map(function (location) {
          return locationPageToResult(location, query);
        })
        .filter(function (result) {
          return result.score > 0 && result.title && result.url;
        });
      var mappingResults = locationMappings
        .map(function (mapping) {
          var score = scoreLocationMapping(query, mapping);

          return mappingToLocationResult(mapping, score);
        })
        .filter(function (result) {
          return result.score > 0 && result.title && result.url;
        });
      var hubResults = cityHubs
        .map(function (hub) {
          var hubText = normalize(
            [hub.title, hub.cityName, hub.state, hub.stateCode].join(" "),
          );
          var score = 0;

          if (compact(hub.title || hub.cityName) === compactQuery) {
            score = 170;
          } else if (hubText.indexOf(normalizedQuery) === 0) {
            score = 130;
          } else if (
            stateQuery &&
            (normalize(hub.state) === stateQuery ||
              normalize(hub.stateCode) === normalize(query))
          ) {
            score = 110;
          }

          return hubToLocationResult(hub, score);
        })
        .filter(function (result) {
          return result.score > 0 && result.title && result.url;
        });

      var results = dedupeByUrl(
        locationPageResults.concat(mappingResults, hubResults).sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return normalize(a.title).localeCompare(normalize(b.title));
        })
      ).slice(0, limit || 5);

      return results;
    }

    function getNearestLocationMatches(lat, lng, limit) {
      return cityHubs
        .filter(function (hub) {
          return hub.lat !== null && hub.lng !== null;
        })
        .map(function (hub) {
          var distance = calculateDistanceMiles(lat, lng, hub.lat, hub.lng);
          var result = hubToLocationResult(hub, 180 - Math.round(distance));

          result.distance = distance;
          return result;
        })
        .filter(function (result) {
          return !!(
            result.title &&
            result.url &&
            result.distance <= nearbyLocationRadiusMiles
          );
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        })
        .slice(0, limit || 5);
    }

    function getNearestEventMatches(lat, lng, limit) {
      return eventIndex
        .filter(function (event) {
          return event.lat !== null && event.lng !== null;
        })
        .map(function (event) {
          return Object.assign({}, event, {
            distance: calculateDistanceMiles(lat, lng, event.lat, event.lng),
          });
        })
        .filter(function (event) {
          return event.distance <= nearbyEventRadiusMiles;
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        })
        .slice(0, limit || 4);
    }

    function getEventSearchMatches(query, limit) {
      var normalizedQuery = normalize(query);

      if (!normalizedQuery) return [];

      return eventIndex
        .map(function (event) {
          var categoryText = (event.categories || []).join(" ");
          var text = normalize(
            [
              event.title,
              event.location,
              event.city,
              event.state,
              event.stateCode,
              event.zip,
              categoryText,
            ].join(" "),
          );
          var score = 0;

          if (normalize(event.title).indexOf(normalizedQuery) !== -1) {
            score = 100;
          } else if (text.indexOf(normalizedQuery) !== -1) {
            score = 70;
          }

          return Object.assign({}, event, { score: score });
        })
        .filter(function (event) {
          return event.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score;
        })
        .slice(0, limit || 4);
    }

    function renderLocationMatches(locations) {
      if (!locationList) return;

      locationList.innerHTML = locations.length
        ? locations
            .map(function (location) {
              return (
                "<li>" +
                '<a href="' +
                escapeHtml(location.url) +
                '">' +
                escapeHtml(location.title) +
                (location.label
                  ? "<small>" + escapeHtml(location.label) + "</small>"
                  : "") +
                "</a></li>"
              );
            })
            .join("")
        : '<li class="home-events-predictive-search__empty">No matching locations found.</li>';
    }

    function renderEventMatches(events) {
      if (!eventList) return;

      eventList.innerHTML = events.length
        ? events
            .map(function (event) {
              var imageHtml = event.image
                ? '<img class="home-events-predictive-search__event-thumb" src="' +
                  escapeHtml(event.image) +
                  '" alt="" loading="lazy">'
                : '<span class="home-events-predictive-search__event-thumb home-events-predictive-search__event-thumb--lights" aria-hidden="true"></span>';

              return (
                '<li><a href="' +
                escapeHtml(event.url) +
                '">' +
                imageHtml +
                "<span><strong>" +
                escapeHtml(event.title) +
                "</strong>" +
                (event.location
                  ? "<small>" + escapeHtml(event.location) + "</small>"
                  : "") +
                "</span></a></li>"
              );
            })
            .join("")
        : '<li class="home-events-predictive-search__empty">No matching events found.</li>';
    }

    function renderAutocompleteResults(query) {
      var requestId = (autocompleteRequestId += 1);
      var locationMatches = getLocationSearchMatches(query, 5);
      var eventMatches = getEventSearchMatches(query, 4);
      var eventTypeMatches = getEventTypeSearchMatches(query, 5);

      renderLocationMatches(locationMatches);
      renderEventMatches(eventMatches);
      renderEventTypeMatches(eventTypeMatches);

      if (
        !geoapifyApiKey ||
        (locationMatches[0] && locationMatches[0].score >= 330) ||
        normalize(query).length < 2
      ) {
        return;
      }

      resolveGeoLocation(query, geoapifyApiKey, toNumber).then(function (
        geoLocation
      ) {
        var nearestLocations;
        var nearestEvents;

        if (requestId !== autocompleteRequestId || !geoLocation) return;

        nearestLocations = getNearestLocationMatches(
          geoLocation.lat,
          geoLocation.lng,
          5
        );
        nearestEvents = getNearestEventMatches(
          geoLocation.lat,
          geoLocation.lng,
          4
        );

        if (nearestLocations.length) renderLocationMatches(nearestLocations);
        if (!eventMatches.length && nearestEvents.length) {
          renderEventMatches(nearestEvents);
        }
      });
    }

    function updateVisibleSuggestions() {
      var query = normalize(input.value);
      var visibleTypes;

      updateAllResults(query);

      if (nearbyResultsActive) return;

      if (query) {
        renderAutocompleteResults(input.value);
        return;
      }

      restoreDefaultResults();

      if (currentMode === "locations") {
        filterList(locationList, query);
        filterList(eventList, query);
      } else if (currentMode === "event-types") {
        filterList(eventList, query);
        visibleTypes = filterList(eventTypeList, query);
        eventTypeEmpty = eventTypeList
          ? eventTypeList.querySelector("[data-home-events-event-type-empty]")
          : null;
        if (eventTypeEmpty) eventTypeEmpty.hidden = visibleTypes > 0;
      } else {
        filterList(locationList, query);
        filterList(eventList, query);
        visibleTypes = filterList(eventTypeList, query);
        eventTypeEmpty = eventTypeList
          ? eventTypeList.querySelector("[data-home-events-event-type-empty]")
          : null;
        if (eventTypeEmpty) eventTypeEmpty.hidden = visibleTypes > 0;
      }
    }

    function restoreDefaultResults() {
      if (locationList && locationList.innerHTML !== defaultLocationListHtml) {
        locationList.innerHTML = defaultLocationListHtml;
      }
      if (eventList && eventList.innerHTML !== defaultEventListHtml) {
        eventList.innerHTML = defaultEventListHtml;
      }
      if (
        eventTypeList &&
        eventTypeList.innerHTML !== defaultEventTypeListHtml
      ) {
        eventTypeList.innerHTML = defaultEventTypeListHtml;
      }
      if (nearbyWrap) nearbyWrap.hidden = false;
    }

    function setNearbyState(state, message) {
      nearbyButtons.forEach(function (button) {
        var label = button.querySelector("[data-home-events-nearby-label]");
        var defaultLabel;

        button.classList.toggle("is-loading", state === "loading");
        button.disabled = state === "loading";
        if (label) {
          defaultLabel =
            button.dataset.homeEventsNearbyDefaultLabel || label.textContent;
          button.dataset.homeEventsNearbyDefaultLabel = defaultLabel;
          label.textContent = state === "loading" ? "Finding..." : defaultLabel;
        }
      });

      if (nearbyStatus) nearbyStatus.textContent = message || "";
    }

    function getNearestCityHubs(lat, lng, limit) {
      var mappingHubs = locationMappings
        .map(function (mapping) {
          return mapping.hub;
        })
        .filter(Boolean);
      var hubs = dedupeByUrl(cityHubs.concat(mappingHubs));

      return hubs
        .filter(function (hub) {
          return hub.lat !== null && hub.lng !== null;
        })
        .map(function (hub) {
          var distance = calculateDistanceMiles(lat, lng, hub.lat, hub.lng);

          return {
            title: hub.title || hub.cityName,
            url: normalizeUrl(hub.url || hub.cityUrl),
            label: uniqueDisplayParts([hub.state, hub.stateCode]).join(", "),
            distance: distance,
          };
        })
        .filter(function (hub) {
          return !!(
            hub.title &&
            hub.url &&
            hub.distance <= nearbyLocationRadiusMiles
          );
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        })
        .slice(0, limit || 5);
    }

    function getNearestEvents(lat, lng, limit) {
      return eventIndex
        .filter(function (event) {
          return event.lat !== null && event.lng !== null;
        })
        .map(function (event) {
          return Object.assign({}, event, {
            distance: calculateDistanceMiles(lat, lng, event.lat, event.lng),
          });
        })
        .filter(function (event) {
          return event.distance <= nearbyEventRadiusMiles;
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        })
        .slice(0, limit || 4);
    }

    function renderNearbyLocations(locations) {
      if (!locationList) return;

      locationList.innerHTML = locations.length
        ? locations
            .map(function (location) {
              return (
                "<li>" +
                '<a href="' +
                escapeHtml(location.url) +
                '">' +
                escapeHtml(location.title) +
                "<small>" +
                escapeHtml(location.label) +
                "</small>" +
                "</a>" +
                "</li>"
              );
            })
            .join("")
        : '<li class="home-events-predictive-search__empty">No city guides found within ' +
          nearbyLocationRadiusMiles +
          " miles.</li>";
    }

    function renderNearbyEvents(events) {
      if (!eventList) return;

      if (!events.length) {
        eventList.innerHTML =
          '<li class="home-events-predictive-search__empty">No nearby events found within ' +
          nearbyEventRadiusMiles +
          " miles.</li>";
        return;
      }

      eventList.innerHTML = events
        .map(function (event) {
          var imageHtml = event.image
            ? '<img class="home-events-predictive-search__event-thumb" src="' +
              escapeHtml(event.image) +
              '" alt="" loading="lazy">'
            : '<span class="home-events-predictive-search__event-thumb home-events-predictive-search__event-thumb--lights" aria-hidden="true"></span>';

          return (
            "<li>" +
            '<a href="' +
            escapeHtml(event.url) +
            '">' +
            imageHtml +
            "<span><strong>" +
            escapeHtml(event.title) +
            "</strong><small>" +
            escapeHtml(event.location || "") +
            "</small></span></a></li>"
          );
        })
        .join("");
    }

    function getEventTypeTemplateMap() {
      var map = {};

      if (!eventTypeList) return map;

      Array.prototype.slice
        .call(
          eventTypeList.querySelectorAll("[data-home-events-event-type-item]"),
        )
        .forEach(function (item) {
          var title = item.dataset.eventTypeTitle || item.textContent || "";
          var link = item.querySelector("a");

          if (!title || !link) return;

          map[normalize(title)] = {
            title: title.trim(),
            url: link.getAttribute("href") || "#",
            iconHtml: item.querySelector(
              ".home-events-predictive-search__type-icon",
            )
              ? item.querySelector(".home-events-predictive-search__type-icon")
                  .outerHTML
              : "",
          };
        });

      return map;
    }

    function getEventTypeSearchMatches(query, limit) {
      var normalizedQuery = normalize(query);
      var templateMap = getEventTypeTemplateMap();
      var counts = {};
      var resultsByKey = {};
      var eventTypesUrl = predictive.dataset.eventTypesUrl || "#";

      if (!normalizedQuery) return [];

      Object.keys(templateMap).forEach(function (key) {
        var type = templateMap[key];
        var normalizedTitle = normalize(type.title);

        if (
          normalizedTitle.indexOf(normalizedQuery) !== -1 ||
          normalizedQuery.indexOf(normalizedTitle) !== -1
        ) {
          resultsByKey[key] = {
            title: type.title,
            url: type.url,
            iconHtml: type.iconHtml,
            score: normalizedTitle === normalizedQuery ? 120 : 90,
            count: 0,
          };
        }
      });

      eventIndex.forEach(function (event) {
        (event.categories || []).forEach(function (category) {
          var title = String(category || "").trim();
          var key = normalize(title);
          var score = 0;

          if (!key) return;

          if (key === normalizedQuery) {
            score = 130;
          } else if (key.indexOf(normalizedQuery) !== -1) {
            score = 100;
          } else if (normalizedQuery.indexOf(key) !== -1) {
            score = 80;
          }

          if (!score) return;

          counts[key] = (counts[key] || 0) + 1;

          if (!resultsByKey[key]) {
            resultsByKey[key] = {
              title: title,
              url:
                (templateMap[key] && templateMap[key].url) ||
                eventTypesUrl + "#" + handleize(title),
              iconHtml:
                (templateMap[key] && templateMap[key].iconHtml) ||
                '<span class="home-events-predictive-search__type-icon home-events-predictive-search__type-icon--green" aria-hidden="true"></span>',
              score: score,
              count: 0,
            };
          } else {
            resultsByKey[key].score = Math.max(resultsByKey[key].score, score);
          }
        });
      });

      return Object.keys(resultsByKey)
        .map(function (key) {
          var result = resultsByKey[key];

          result.count = counts[key] || result.count || 0;
          return result;
        })
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          if (b.count !== a.count) return b.count - a.count;
          return normalize(a.title).localeCompare(normalize(b.title));
        })
        .slice(0, limit || 5);
    }

    function renderEventTypeMatches(types) {
      if (!eventTypeList) return;

      eventTypeList.innerHTML = types.length
        ? types
            .map(function (type) {
              return (
                '<li data-home-events-event-type-item data-event-type-title="' +
                escapeHtml(type.title) +
                '">' +
                '<a href="' +
                escapeHtml(type.url || "#") +
                '">' +
                type.iconHtml +
                '<span class="home-events-predictive-search__type-text">' +
                escapeHtml(type.title) +
                (type.count
                  ? "<small>" +
                    type.count +
                    " matching " +
                    (type.count === 1 ? "event" : "events") +
                    "</small>"
                  : "") +
                "</span></a></li>"
              );
            })
            .join("")
        : '<li class="home-events-predictive-search__empty">No matching event types found.</li>';
    }

    function renderNearbyEventTypes(events) {
      var templateMap = getEventTypeTemplateMap();
      var counts = {};
      var orderedKeys = [];

      if (!eventTypeList) return;

      events.forEach(function (event) {
        (event.categories || []).forEach(function (category) {
          var key = normalize(category);

          if (!key) return;
          if (!counts[key]) orderedKeys.push(key);
          counts[key] = (counts[key] || 0) + 1;

          if (!templateMap[key]) {
            templateMap[key] = {
              title: category,
              url: predictive.dataset.eventTypesUrl || "#",
              iconHtml:
                '<span class="home-events-predictive-search__type-icon home-events-predictive-search__type-icon--green" aria-hidden="true"></span>',
            };
          }
        });
      });

      orderedKeys.sort(function (a, b) {
        return counts[b] - counts[a];
      });

      if (!orderedKeys.length) {
        eventTypeList.innerHTML =
          '<li class="home-events-predictive-search__empty">No event types found within ' +
          nearbyEventRadiusMiles +
          " miles. Add Event Category metafields to nearby events.</li>";
        return;
      }

      eventTypeList.innerHTML = orderedKeys
        .map(function (key) {
          var type = templateMap[key];
          var count = counts[key];

          return (
            '<li data-home-events-event-type-item data-event-type-title="' +
            escapeHtml(type.title) +
            '">' +
            '<a href="' +
            escapeHtml(type.url) +
            '">' +
            type.iconHtml +
            '<span class="home-events-predictive-search__type-text">' +
            escapeHtml(type.title) +
            "<small>" +
            count +
            " nearby " +
            (count === 1 ? "event" : "events") +
            "</small></span></a></li>"
          );
        })
        .join("");
    }

    function requestNearbyLocation(event) {
      if (event) event.preventDefault();

      openSearch();
      setMode("all", input.getAttribute("placeholder"), "Search All");
      input.value = "Near me";
      nearbyResultsActive = true;
      if (nearbyWrap) nearbyWrap.hidden = true;
      updateAllResults();

      if (!navigator.geolocation) {
        setNearbyState("error", "Location is unavailable in this browser.");
        renderNearbyLocations([]);
        renderNearbyEvents([]);
        renderNearbyEventTypes([]);
        return;
      }

      setNearbyState("loading", "Finding nearby Christmas events.");

      navigator.geolocation.getCurrentPosition(
        function (position) {
          var coords = position && position.coords ? position.coords : null;
          var locations = coords
            ? getNearestCityHubs(coords.latitude, coords.longitude, 5)
            : [];
          var events = coords
            ? getNearestEvents(coords.latitude, coords.longitude, 4)
            : [];

          renderNearbyLocations(locations);
          renderNearbyEvents(events);
          renderNearbyEventTypes(events);
          setNearbyState(
            "ready",
            locations.length || events.length
              ? "Nearby results are available."
              : "No nearby results found.",
          );
        },
        function () {
          setNearbyState("error", "Location access was denied or unavailable.");
          renderNearbyLocations([]);
          renderNearbyEvents([]);
          renderNearbyEventTypes([]);
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 1000 * 60 * 15,
        },
      );
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        setMode(
          tab.dataset.tab,
          tab.dataset.placeholder,
          tab.textContent.trim(),
        );
        openSearch();
        input.focus();
      });
    });

    if (selectButton && selectList) {
      selectButton.addEventListener("click", function () {
        var willOpen = selectList.hidden;

        root.classList.toggle("is-mobile-select-open", willOpen);
        selectList.hidden = !willOpen;
        selectButton.setAttribute("aria-expanded", willOpen ? "true" : "false");
        openSearch(false);
      });
    }

    selectOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        setMode(
          option.dataset.value,
          option.dataset.placeholder,
          option.textContent.trim(),
        );
        input.focus();
      });
    });

    input.addEventListener("focus", function () {
      openSearch();
    });

    input.addEventListener("click", function () {
      openSearch();
    });

    input.addEventListener("input", function () {
      if (nearbyResultsActive) {
        nearbyResultsActive = false;
        restoreDefaultResults();
        setNearbyState("ready", "");
      }
      openSearch(false);
      updateVisibleSuggestions();
    });

    input.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeSearch();
        input.blur();
      }
    });

    form.addEventListener("submit", function (event) {
      var query = input.value.trim();

      if (!query) {
        event.preventDefault();
        openSearch();
        input.focus();
        return;
      }
    });

    if (overlay) {
      overlay.addEventListener("click", closeSearch);
    }

    nearbyButtons.forEach(function (button) {
      button.addEventListener("click", requestNearbyLocation);
    });

    document.addEventListener("click", function (event) {
      if (!isOpen) return;
      if (panel.contains(event.target)) return;
      closeSearch();
    });

    root.addEventListener("shopify:section:unload", closeSearch);
  }

  ready(function () {
    Array.prototype.slice
      .call(
        document.querySelectorAll(
          "[data-section-type='home-events-hero-search']",
        ),
      )
      .forEach(initHomeEventsHeroSearch);
  });
})();
